import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

type WhatsappConfig = {
  link: string;
  visible: boolean;
};

export function useWhatsappConfig(): WhatsappConfig | null {
  const { data } = useQuery({
    queryKey: ['whatsapp-config'],
    queryFn: async (): Promise<WhatsappConfig> => {
      const r = await pb.send('/api/config/public', { method: 'GET' });
      return {
        link: (r['whatsapp_group_link'] as string) ?? '',
        visible: r['whatsapp_group_link_visible'] === true,
      };
    },
    staleTime: 60_000,
  });
  return data ?? null;
}
